<template>
  <div>
    <IconBox :icon-data-list="vertragsServicesDataIconList"></IconBox>
  </div>
</template>

<script setup lang="ts">
import { type IconDataSpan } from 'de-zurich-ui-library'
import IconBox from '@/components/common/IconBox.vue'
import i18n from '@/i18n'
import { computed } from 'vue'
import { isRedCooperationPartner } from '@/utilsTenant/RedCooperationUtils'
import { isTrue } from '@/utils/CommonUtils'

const changeMotorVersicherungsumfangUrl: string =
  globalThis.ENV_CONFIG?.SERVICE_LINKS.VERTRAGSSERVICES_PAGE
    .CHANGE_MOTORVERSICHERUNGSUMFANG_PAGE
const changeMotorFahrleistungUrl: string =
  globalThis.ENV_CONFIG?.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.CHANGE_MOTORFAHRLEISTUNG_PAGE
const changeMotorFahrerkreisUrl: string =
  globalThis.ENV_CONFIG?.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.CHANGE_MOTORFAHRERKREIS_PAGE
const requestDigitalCardUrl: string =
  globalThis.ENV_CONFIG?.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.REQUEST_DIGITALCARD_PAGE
const requestIvkUrl: string =
  globalThis.ENV_CONFIG?.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.REQUEST_IVK_PAGE
const requestAccompanyingDrivingCertificatUrl: string =
  globalThis.ENV_CONFIG?.SERVICE_LINKS.ACCOMPANYING_DRIVING
const requestVehicleSaleUrl: string =
  globalThis.ENV_CONFIG?.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.REQUEST_VEHICLESALE_PAGE

const vertragsServicesDataIconList = computed(() => {
  const changeMotorVersicherungsumfang: IconDataSpan = {
    iconClass: 'deckungsumfang',
    href: changeMotorVersicherungsumfangUrl,
    label: i18n.global
      .t('vertragsServicesIcons.changeMotorVersicherungsumfang')
      .toString()
  }
  const changeMotorFahrleistung: IconDataSpan = {
    iconClass: 'lex-fahrleistung',
    href: changeMotorFahrleistungUrl,
    label: i18n.global.t('vertragsServicesIcons.changeMotorFahrleistung').toString()
  }
  const changeMotorFahrerkreis: IconDataSpan = {
    iconClass: 'fahrerkreis',
    href: changeMotorFahrerkreisUrl,
    label: i18n.global.t('vertragsServicesIcons.changeMotorFahrerkreis').toString()
  }
  const requestDigitalCard: IconDataSpan = {
    iconClass: 'VS_Wallet',
    href: requestDigitalCardUrl,
    label: i18n.global.t('vertragsServicesIcons.requestDigitalCard').toString()
  }
  const requestIvkIcon: IconDataSpan = {
    iconClass: 'ivkDefault',
    href: requestIvkUrl,
    label: i18n.global.t('vertragsServicesIcons.requestIvk').toString()
  }
  const requestAccompanyingDrivingCertificatIcon: IconDataSpan = {
    iconClass: 'ausweis_outline',
    href: requestAccompanyingDrivingCertificatUrl,
    label: i18n.global
      .t('vertragsServicesIcons.requestAccompanyingDrivingCertificat')
      .toString()
  }
  const requestVehicleSaleIcon: IconDataSpan = {
    iconClass: 'soldCar',
    href: requestVehicleSaleUrl,
    label: i18n.global.t('vertragsServicesIcons.requestVehicleSale').toString()
  }

  let servicesList: IconDataSpan[]
  if (isRedCooperationPartner()) {
    servicesList = [
      requestIvkIcon,
      requestAccompanyingDrivingCertificatIcon,
      requestVehicleSaleIcon
    ]
  } else {
    servicesList = [
      changeMotorVersicherungsumfang,
      changeMotorFahrleistung,
      changeMotorFahrerkreis,
      requestIvkIcon,
      requestAccompanyingDrivingCertificatIcon,
      requestVehicleSaleIcon
    ]
  }
  if (isTrue(globalThis.ENV_CONFIG?.FEATURE_FLAGS.ENABLE_DIGITAL_CARD)) {
    servicesList.splice(3, 0, requestDigitalCard)
  }
  return servicesList
})
</script>
